import { render } from "./academics.vue?vue&type=template&id=7ea91b48&scoped=true"
import script from "./academics.vue?vue&type=script&lang=js"
export * from "./academics.vue?vue&type=script&lang=js"

import "./academics.vue?vue&type=style&index=0&id=7ea91b48&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7ea91b48"

export default script